// Presenter Archetype — pure deterministic scoring (presenter-archetype-v1).
// Exact JS port of the reference algorithm in the implementation brief (§6)
// and of `backend/presenter_archetype/scoring.py` — both must stay in sync
// with each other and with the brief; this is locked v1 content/logic.
// No AI, no network — pure function, used for the instant on-screen result.
// The backend independently recomputes the SAME function before trusting
// any submission (lead save / PDF) — a client can never submit its own
// scores/leaders and have them trusted.

export const ARCHETYPE_IDS = ["architect", "storyteller", "energiser", "guide"];
export const QUESTION_COUNT = 7;

export function scorePresenterArchetype(answers) {
  if (
    !Array.isArray(answers) ||
    answers.length !== QUESTION_COUNT ||
    !answers.every((a) => ARCHETYPE_IDS.includes(a))
  ) {
    throw new Error("Complete all seven questions with a valid answer.");
  }

  const scores = Object.fromEntries(ARCHETYPE_IDS.map((id) => [id, 0]));
  answers.forEach((a) => {
    scores[a] += 1;
  });

  const maximum = Math.max(...Object.values(scores));
  const leaders = ARCHETYPE_IDS.filter((id) => scores[id] === maximum);
  const others = ARCHETYPE_IDS.filter((id) => !leaders.includes(id));
  const secondaryMaximum = Math.max(0, ...others.map((id) => scores[id]));
  const secondary =
    leaders.length === 1 && secondaryMaximum > 0
      ? others.filter((id) => scores[id] === secondaryMaximum)
      : [];
  const minimum = Math.min(...Object.values(scores));
  const stretch = ARCHETYPE_IDS.filter((id) => scores[id] === minimum);

  return { scores, leaders, secondary, stretch, maximum, total: QUESTION_COUNT };
}
